"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Header_1 = tslib_1.__importDefault(require("../../Header"));
const Icon_1 = tslib_1.__importDefault(require("../../Icon"));
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const Wrapper = (0, styled_components_1.default)('div') `
  display: flex;
  justify-content: space-between;
`;
const Text = (0, styled_components_1.default)('div') `
  width: 100%;
  ${({ $disabled, theme }) => $disabled &&
    (0, styled_components_1.css) `
      color: ${theme.color.fadedText};
    `};
`;
const ClickableText = (0, styled_components_1.default)(Text) `
  width: 100%;
  cursor: pointer;
`;
const Actions = (0, styled_components_1.default)('div') `
  display: flex;
  align-items: center;
`;
const IconWrapper = (0, styled_components_1.default)('button') `
  /* resets button styles */
  padding: 0;
  border: none;
  font: inherit;
  background-color: transparent;
  text-align: inherit;

  cursor: pointer;
  transition: 0.2s linear all;

  align-items: center;
  ${({ $disabled, theme }) => $disabled &&
    (0, styled_components_1.css) `
      cursor: not-allowed;
      color: ${theme.color.fadedText};
    `};
`;
const StyleIcon = (0, styled_components_1.default)(Icon_1.default) `
  width: 100%;
  height: 100%;
  align-items: center;
  ${({ $isRotate }) => $isRotate &&
    (0, styled_components_1.css) `
      transform: rotate(180deg);
    `};
`;
const defaultProps = {
    size: 'm',
    noBottomGutter: false,
};
class SegmentHeader extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.collapse = () => {
            const { toggleCollapse, isCollapsed, disabled } = this.props;
            if (!disabled && toggleCollapse) {
                toggleCollapse(!isCollapsed);
            }
        };
        this.renderActions = () => {
            const { collapsible, onDispose, size, disabled, isCollapsed } = this.props;
            const actionIconSize = typeof size === 'string' ? this.sizeToPx(size) : size;
            const actions = [];
            if (collapsible) {
                actions.push(React.createElement(IconWrapper, { key: "collapse", onClick: this.collapse, type: "button", disabled: disabled, "data-testid": "Segment-IconArrowDown" }, disabled ? (React.createElement(StyleIcon, { name: "arrow-down", size: actionIconSize, "$isRotate": isCollapsed, color: "#e0e0eb" })) : (React.createElement(StyleIcon, { name: "arrow-down", size: actionIconSize, "$isRotate": isCollapsed }))));
            }
            if (onDispose) {
                actions.push(React.createElement(IconWrapper, { key: "close", onClick: onDispose, disabled: disabled, "data-testid": "Segment-IconClose" }, disabled ? (React.createElement(Icon_1.default, { name: "close", size: actionIconSize, color: "#e0e0eb" })) : (React.createElement(Icon_1.default, { name: "close", size: actionIconSize }))));
            }
            return actions;
        };
    }
    sizeToPx(size) {
        const sizeMapping = {
            xs: 16,
            s: 18,
            m: 20,
            l: 22,
            xl: 24,
        };
        return size in sizeMapping ? sizeMapping[size] : 16;
    }
    render() {
        const { size, subtitle, withSeparator, noBottomGutter, children, collapsible, disabled, className, icon, } = this.props;
        return (React.createElement(Header_1.default, { noBottomGutter: noBottomGutter, subtitle: subtitle, size: size, withSeparator: withSeparator, className: className, icon: icon },
            React.createElement(Wrapper, null,
                collapsible ? (React.createElement(ClickableText, { "$disabled": disabled, onClick: this.collapse }, children)) : (React.createElement(Text, { "$disabled": disabled }, children)),
                React.createElement(Actions, null, this.renderActions()))));
    }
}
SegmentHeader.defaultProps = defaultProps;
exports.default = (0, styled_components_1.withTheme)(SegmentHeader);
